import React, { FunctionComponent, useContext } from "react";
import { AppStore } from "../../app/store";
import { FocusableHeader, SimpleHeader, StateSelector } from "../../components";
import { sendTealiumEvent, useQueryParams, useTranslate } from "../../helpers";
import { linkToPaceInfo } from "../../helpers/CONSTANTS";
import { RouteComponentProps, withRouter } from "react-router";

const PaceLandingPage: FunctionComponent<RouteComponentProps> = ({
  location,
  history,
  match,
}) => {
  const t = useTranslate();
  const {
    state: { language },
  } = useContext(AppStore.AppContext);
  useQueryParams({ location, history, match });

  return (
    <div className="PaceLandingPage">
      <div className="PaceLandingPage__hero">
        <SimpleHeader noBorder={true} variation="dark" hideLogin={true} />
        <div className="PaceLandingPage__heroContent">
          <FocusableHeader
            className="PaceLandingPage__heroHeader"
            text={t("pace.landing.header")}
            ignoreFocus={false}
          />
          <div className="ds-u-measure--wide mct-p1 ds-u-color--white ds-u-text-align--center ds-u-margin-top--2 ds-u-margin-bottom--7">
            {t("pace.landing.subheader")}
          </div>
        </div>
      </div>

      <div className="PaceLandingPage__content">
        <div className="PaceLandingPage__card">
          <StateSelector
            buttonText={t("pace.state_selector.button_text")}
            defaultLabel={t("pace.state_selector.select_state")}
            programType="PACE"
          />
          <p>
            {t("pace.landing.state_disclaimer")}{" "}
            <a
              href={linkToPaceInfo(language)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                sendTealiumEvent(
                  "Internal Link Click",
                  `Learn more about PACE:${linkToPaceInfo(language)}`,
                  { event_category: "PACE" }
                );
              }}
            >
              {t("pace.landing.learn_more")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PaceLandingPage);
